var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LpButton',{attrs:{"disabled":_vm.disabled || _setup.isBasketLocked,"spinner":_setup.pending},on:{"click":function($event){return _setup.onAdd()}}},[_vm._v("\n    "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"material-icons u-align-middle u-ml-2"},[_vm._v("")])])
}
var staticRenderFns = []

export { render, staticRenderFns }